import React, { useState, useEffect} from "react";
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AddressForm from "./AddressForm";
import I18n from 'i18n.js.erb'
import {EMPTY_ADDRESS, IPAD_WIDTH, isValidUserAddress, parseUserFullName} from "../../utils/utils";
import PaypalButton from "./PaypalButton";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
    }
  }),
);


const PaymentAndShippingForm = ({
  numberOfProducts,
  shipment_addresses,
  confirmHandler,
  validShipmentAddress,
  setValidShipmentAddress,
  countries,
  submited,
  descriptionTitle,
  environment,
  amount,
  enablePayment,
  paypalClientId,
  disableConfirmButton,
  dataForPaypalButton,
  canUpdate,
  deliveryMethod,
  enableVoucherInput,
  voucher,
  setVoucher
}) => {

  const [shipmentAddress, setShipmentAddress] = useState(EMPTY_ADDRESS)
  const [ checkedShipmentAddressId, setCheckedShipmentAddressId ] = useState(
    shipment_addresses.length > 0 ?
      (shipment_addresses.find((shipment) => shipment.is_default) ? shipment_addresses.find((shipment) => shipment.is_default).id : shipment_addresses[0].id)
      :
      null
  )
  const [ createNewAddress, setCreateNewAddress ] = useState(shipment_addresses.length === 0)
  const [ defaultSettings, setDefaultsettings ] = useState(false)
  const classes = useStyles();
  const [ expanded, setExpanded ] = useState('panel1');
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    setCreateNewAddress(panel === 'panel2')
  };


  useEffect(() => {
    if (deliveryMethod?.meta_name?.toLowerCase()?.indexOf('by hand') > -1) {
      setShipmentAddress(EMPTY_ADDRESS)
      setCheckedShipmentAddressId(null)
      setDefaultsettings(false)
      setValidShipmentAddress(true)
    }
  }, [deliveryMethod]);

  // Funzione che permette di aggiornare i vari campi che compongono l'indirizzo di spedizione
  // con i dati immessi dall'utente sull'interfaccia grafica
  const updateShipmentAddressParams = (keys, values) => {
    const newShipmentAddress = {...shipmentAddress}
    for (let i = 0; i < keys.length; i++)
      newShipmentAddress[keys[i]] = values[i]
    setShipmentAddress(newShipmentAddress)
  }


  // Funzione che gestisce la conferma di pagamento da parte dell'utente
  const confirmPaymentHandler = (paymentTransactionId) => {
    confirmHandler(shipmentAddress, createNewAddress, checkedShipmentAddressId, defaultSettings, paymentTransactionId)
  }


  return (
    <div className={`${ $(window).innerWidth() < IPAD_WIDTH && 'container'}`}>
      <div className="row">
        <div className="col-12 p-0">
          {
            numberOfProducts > 0 &&
              <div className={`d-flex mb-20px-imp ${ $(window).innerWidth() < IPAD_WIDTH ? 'm-auto justify-content-center'  :'justify-content-end'}`}>
                {
                  environment !== 'submission_list' || !enablePayment ?
                    <button
                      type="button"
                      disabled={disableConfirmButton || (createNewAddress && !isValidUserAddress(shipmentAddress, deliveryMethod) || (!createNewAddress && !checkedShipmentAddressId && deliveryMethod?.meta_name?.toLowerCase()?.indexOf('by hand') === -1))}
                      className="btn-standard bg-aig-gradient text-light br-20px shadow pr-2 pl-2 btn-standard-resized h-75 mt-20px minW-350px"
                      onClick={() => {
                        confirmHandler(shipmentAddress, createNewAddress, checkedShipmentAddressId, defaultSettings)
                      }}
                    >
                      {I18n.t('js.common.button.confirm').toUpperCase()}
                    </button>
                  :
                    paypalClientId ?
                      <PaypalButton
                        amount={amount}
                        confirmHandler={confirmPaymentHandler}
                        disabled={disableConfirmButton || (createNewAddress && !isValidUserAddress(shipmentAddress, deliveryMethod) || (!createNewAddress && !checkedShipmentAddressId && deliveryMethod?.meta_name?.toLowerCase()?.indexOf('by hand') === -1))}
                        paypalClientId={paypalClientId}
                        locale={I18n.locale}
                        dataForPaypalButton={
                          {
                            ...dataForPaypalButton,
                            shipmentAddresses: shipmentAddress,
                            defaultSettings: defaultSettings,
                            checkedShipmentAddressId: checkedShipmentAddressId
                          }
                        }
                      />
                      :
                        <div className="d-flex align-items-center text-aiBlue">
                          <div className="spinner-border" role="status" />
                          <span className="ml-2"><b>{I18n.t('js.editSubmissionListPage.paymentMethodUpdate')}</b></span>
                        </div>
                }
              </div>
          }
        </div>

        {
          enableVoucherInput &&
            <div className="col-12 d-block p-0 mb-5">
              <h4 className="text-weight-700 text-space mb-0">
                {I18n.t('js.editSubmissionListPage.enterCoupon')}
              </h4>

              <input
                type="text"
                className={`form-control mt-2 w-50 ${voucher?.is_valid ? 'border-aiG-green-imp' : (voucher?.is_valid === false ? 'border-aiG-red-imp' : '')}`}
                value={voucher?.code ? voucher.code : ''}
                onChange={(e) => setVoucher({ ...voucher, code: e.target.value })}
                placeholder={I18n.t('js.editSubmissionListPage.couponPlacehoder')}
              />

              {
                voucher?.is_valid ?
                  <p className="color-green mt-1">
                    <i className="fas fa-fw fa-check mr-1" />
                    {I18n.t('js.editSubmissionListPage.couponValid')}
                  </p>
                :
                  voucher?.is_valid === false &&
                    <p className="color-red mt-1">
                      <i className="fas fa-fw fa-times mr-1" />
                      {I18n.t('js.editSubmissionListPage.couponInvalid')}
                    </p>
              }
            </div>
        }

        <div className="col-12 d-block p-0">
          <h4 className="text-weight-700 text-space mb-0">
            {descriptionTitle}
          </h4>
        </div>

        {
          shipment_addresses.length > 0 ?
            <div className={`no-margins ${classes.root} mt-1`}>
              <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <h3 className="text-space text-black-imp">{I18n.t('js.paymentAndShippingComponent.myAddresses')}</h3>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="d-block">
                    {shipment_addresses.map((shipment, i) => {
                      return <div key={"shipment_" + shipment.id}
                                  className={`d-flex justify-content-start ${i > 0 ? 'mt-5' : 'mt-2'}`}
                                  style={{ fontSize: '20px' }}>
                        <input type="radio"
                               disabled={submited || !canUpdate || deliveryMethod?.meta_name?.toLowerCase()?.indexOf('by hand') > -1}
                               value={shipment.id}
                               checked={shipment.id === checkedShipmentAddressId}
                               id={"shipment_radio_" + shipment.id}
                               className="ml-5 aiG-radio custom-control-input"
                               onChange={ (e) => setCheckedShipmentAddressId(shipment.id) }
                        />
                        <label className="pr-3 ml-3 aiG-label-radio custom-control-label text-weight-300" htmlFor={"shipment_radio_" + shipment.id}>
                          {parseUserFullName(shipment.first_name, shipment.last_name) + ',  ' + shipment.street_square + ' ' + shipment.number}
                          {shipment.indoor + ' ' + shipment.cap + ' ' + shipment.city + ' - ' + shipment.province + ' (' + shipment.country + ') '}
                          {shipment.phone_number ? ', ' + shipment.phone_number : ''}
                        </label>
                      </div>
                    })}
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <h3 className="text-space text-black-imp">{I18n.t('js.paymentAndShippingComponent.newAddress')}</h3>
                </AccordionSummary>
                <AccordionDetails>
                  <AddressForm
                    shipmentAddress={shipmentAddress}
                    updateShipmentAddressParams={updateShipmentAddressParams}
                    validShipmentAddress={validShipmentAddress}
                    countries={countries}
                    submited={submited}
                    canUpdate={canUpdate && (!deliveryMethod || deliveryMethod?.meta_name?.toLowerCase()?.indexOf('by hand') === -1)}
                    addressType={'user'}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
          :
            <div className="w-100 mt-2">
              <AddressForm
                shipmentAddress={shipmentAddress}
                updateShipmentAddressParams={updateShipmentAddressParams}
                validShipmentAddress={validShipmentAddress}
                countries={countries}
                submited={submited}
                canUpdate={canUpdate && (!deliveryMethod || deliveryMethod?.meta_name?.toLowerCase()?.indexOf('by hand') === -1)}
                addressType={'user'}
              />
            </div>
        }


        <div className="mt-3">
          <div className="row">
            <div className="col-12 d-flex align-items-center">
              {
                numberOfProducts > 0 &&
                <React.Fragment>
                  <input
                    type="checkbox"
                    disabled={submited || !canUpdate || deliveryMethod?.meta_name?.toLowerCase()?.indexOf('by hand') > -1}
                    checked={defaultSettings}
                    id="default_settings"
                    onChange={() => setDefaultsettings(!defaultSettings)}
                    className="mt-0"
                  />
                  <label className="pr-3 ml-1 mb-0 text-weight-300" htmlFor="default_settings">
                    {I18n.t('js.paymentAndShippingComponent.useForFuture')}
                  </label>
                </React.Fragment>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default PaymentAndShippingForm;